import React, { useEffect, useState } from "react";
import { Table, Offcanvas } from "react-bootstrap";
import Moment from "react-moment";
import { useParams } from "react-router";
import { studyOnboardingService } from "../../../../../APIServices/studyOnboarding";
import Pagination from "../../../../Pagination";
import { PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { isHTMLIdentifier } from "../../../../../utils/universalFunction";
const ViewSubjectActivity = ({
  tableRef,
  onMouseDown,
  Show,
  Hide,
  Title,
  subjectId,
}) => {
  let { studyId } = useParams();
  const [subjectActivityCount, setSubjectActivityCount] = useState(0);
  const [subjectActivity, setSubjectActivity] = useState([]);
  const [activityLoader, setActivityLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "subjectData",
      studyId,
      subjectId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setSubjectActivity(data?.data || []);
    setSubjectActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(subjectActivityCount / itemsPerPage);

  useEffect(() => {
    if (subjectId) {
      getStudyAuditTrials(pageNumber, itemsPerPage);
    }
  }, [pageNumber, itemsPerPage, subjectId]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 1200 }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {activityLoader ? (
            <PageLoader />
          ) : (
            <>
              <div className="overflow-auto">
                <Table
                  ref={tableRef}
                  className="m-0 custom-table w-auto"
                  hover
                  striped
                >
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                      >
                        Audit Id
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 1)}
                      >
                        Study Id
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 2)}
                      >
                        Site Id
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 3)}
                      >
                        Subject Id
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 4)}
                      >
                        Event Id
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 5)}
                      >
                        Form Id
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 6)}
                      >
                        Field Name
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 7)}
                      >
                        Sub Field Name
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 8)}
                      >
                        Activity Type
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 9)}>Activities</th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 10)}
                      >
                        Previous Value
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 11)}
                      >
                        Current Value
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 12)}
                      >
                        Activity By
                      </th>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 13)}
                      >
                        Activity Date | Time
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {subjectActivity?.map((item, index) => (
                      <tr>
                        <td>{item?.auditId}</td>
                        <td>{item?.studyName || "_"}</td>
                        <td>{item?.siteName || "_"}</td>
                        <td>{item?.subjectName || "_"}</td>
                        <td>{item?.eventName || "_"} {item?.timePointId ? `(${item?.timePointId})` : ""}</td>
                        <td>{item?.formName || "_"} {item?.formVersion ? `(v${item?.formVersion})` : ""}</td>
                        <td>
                          {item?.mainFieldCode ?
                            <>
                              {isHTMLIdentifier(item?.mainFieldLabel || "") ? (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: item?.mainFieldLabel,
                                  }}
                                />
                              ) : (
                                item?.mainFieldLabel
                              )} ({item?.mainFieldCode})
                            </>
                            : "_"}
                        </td>
                        <td>
                          {item?.fieldCode ?
                            <>
                              {isHTMLIdentifier(item?.fieldLabel || "") ? (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: item?.fieldLabel,
                                  }}
                                />
                              ) : (
                                item?.fieldLabel
                              )} ({item?.fieldCode})
                            </>
                            : ""}
                        </td>
                        <td className="text-uppercase">{item?.actionType.replace(/_/g, " ")}</td>
                        <td>{item?.activities}</td>
                        <td>{item?.previousValue}</td>
                        <td>{item?.updatedValue}</td>
                        <td>{item?.fullName}</td>
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item.createdAt}
                          </Moment>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={subjectActivityCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ViewSubjectActivity;
